import { useSelector } from "react-redux"

export const useRuleValidator = (rule) => {
  const {rules} = useSelector(({login}) => login)
  return rules.includes(rule)
}